module.exports = __webpack_public_path__ + "static/img/4.03a0601b.jpg";